import { Tooltip, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption4 = {
  styleId:4,
  pluginName: [],
  refreshTime: 90000,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "" //不带坐标系
  },
  title: {
    text: "title",
    left: "center",
    show: false
  },
  tooltip: new Tooltip("item", {}),
  legend: new Legend({
    padding: [25, 0, 0, 0],
    left: "left",
    top: "top",
    textStyle: {
      color: "rgba(0, 0, 0, 0.8)",
      fontWeight: "400",
      fontSize: 14
    }
  }),
  series: [
    {
      name: "数据1",
      type: "pie",
      radius: ["0%", "30%"],
      roseType: "",
      center: ["50%", "57%"],
      itemStyle: {
        borderRadius: 0,
        borderColor: "rgba(0,0,0,0.5)",
        borderType: "solid",
        borderWidth: 0
      },
      label: {
        show: false,
        position: "outside",
        formatter: "{b}",
        fontFamily: "sans-serif",
        color: "rgba(0, 0, 0, 0.8)",
        fontWeight: "400",
        fontSize: 14
      },
      labelLine: {
        show: true,
        lineStyle: {
          color: null,
          width: 1,
          type: "solid"
        }
      },
      data: [
        {
          value: 335,
          name: "分类1",
          itemStyle: {
            color: "rgb(0, 71, 255)"
          }
        },
        {
          value: 310,
          name: "分类2",
          itemStyle: {
            color: "rgb(0, 228, 228)"
          }
        },
        {
          value: 234,
          name: "分类3",
          itemStyle: {
            color: "rgb(255, 166, 63)"
          }
        }
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)"
        }
      },
      animationDuration: 1000
    },
    {
      name: "数据2",
      type: "pie",
      radius: ["40%", "65%"],
      roseType: "",
      center: ["50%", "57%"],
      itemStyle: {
        borderRadius: 0,
        borderColor: "rgba(0,0,0,0.5)",
        borderType: "solid",
        borderWidth: 0
      },
      label: {
        show: true,
        position: "outside",
        formatter: "{b}",
        fontFamily: "sans-serif",
        color: "rgba(0, 0, 0, 0.8)",
        fontWeight: "400",
        fontSize: 14
      },
      labelLine: {
        show: true,
        lineStyle: {
          color: null,
          width: 1,
          type: "solid"
        }
      },
      data: [
        {
          value: 335,
          name: "分类1",
          itemStyle: {
            color: "rgb(0, 71, 255)"
          }
        },
        {
          value: 310,
          name: "分类2",
          itemStyle: {
            color: "rgb(0, 228, 228)"
          }
        },
        {
          value: 434,
          name: "分类4",
          itemStyle: {
            color: "rgb(255, 166, 63)"
          }
        },
        {
          value: 280,
          name: "分类3",
          itemStyle: {
            color: "rgb(214, 39, 176)"
          }
        },
        {
          value: 134,
          name: "分类5",
          itemStyle: {
            color: "rgb(192, 53, 227)"
          }
        },
        {
          value: 86,
          name: "分类6",
          itemStyle: {
            color: "rgb(128, 44, 245)"
          }
        }
      ],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.5)"
        }
      },
      animationDuration: 1000
    }
  ]
}
